<template>
  <div class="tarjeta">
    <!-- BADGE de ORDEN -->
<div class="orden-badge">
  #{{ actividad.numero_etapa }}
</div>

    <!-- CABECERA -->
    <div class="tarjeta-header d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <button class="btn btn-sm btn-toggle me-2" @click="toggleMinimizado" :title="minimizado ? 'Mostrar detalles' : 'Ocultar detalles'">
          <font-awesome-icon :icon="minimizado ? 'chevron-down' : 'chevron-up'" />
        </button>
        <h6 class="mb-0 text-dark d-flex align-items-center">
          <font-awesome-icon icon="leaf" class="me-2 text-success" />
          {{ actividad.nombre_tarea }}
        </h6>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-outline-primary btn-sm" @click="toggleEdicion">
          <font-awesome-icon :icon="enEdicion ? 'floppy-disk' : 'pen'" />
        </button>
        <button class="btn btn-outline-danger btn-sm" @click="$emit('eliminar', actividad.id)">
          <font-awesome-icon icon="trash" />
        </button>
      </div>
    </div>

    <!-- CUERPO -->
    <transition name="fade">
      <div v-if="!minimizado" class="tarjeta-body mt-3">
        <div v-if="enEdicion">
          <div class="row g-2">
            <div class="col-md-2 col-sm-4">
              <label class="form-label">Orden</label>
              <input type="number" v-model.number="actividadLocal.numero_etapa" class="form-control form-control-sm" min="1" />
            </div>
            <div class="col-md-4 col-sm-8">
              <label class="form-label">Etapa/Evento</label>
              <select v-model="actividadLocal.etapa_evento_cultivo" class="form-select form-select-sm">
                <option disabled value="">Seleccione una etapa</option>
                <option v-for="evento in eventos" :key="evento.id" :value="evento.nombre_evento">
                  {{ evento.nombre_evento }}
                </option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label">Descripción</label>
              <textarea v-model="actividadLocal.descripcion" rows="2" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Costo</label>
              <input type="number" v-model.number="actividadLocal.costo_estimado_usd" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Horas estimadas</label>
              <input type="text" v-model="actividadLocal.costo_estimado_moneda_alternativa" class="form-control form-control-sm" />
            </div>
          </div>
        </div>

        <!-- MODO LECTURA -->
        <div v-else class="info-compacta">
          <div class="row g-2">
            <div class="col-md-3 col-6">
              <p class="mb-1"><strong>Orden:</strong> {{ actividad.numero_etapa }}</p>
            </div>
            <div class="col-md-5 col-6">
              <p class="mb-1"><strong>Etapa:</strong> {{ actividad.etapa_evento_cultivo }}</p>
            </div>
            <div class="col-md-4 col-12">
              <p class="mb-1"><strong>Descripción:</strong> {{ actividad.descripcion || '—' }}</p>
            </div>
            <div class="col-md-3 col-6">
              <p class="mb-1"><strong>$:</strong> {{ actividad.costo_estimado_usd }}</p>
            </div>
            <div class="col-md-3 col-6">
              <p class="mb-1"><strong>Horas:</strong> {{ actividad.costo_estimado_moneda_alternativa }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>






<script>
import axios from '@/axios';

export default {
  name: 'TareaDelPlan',
  props: {
    actividad: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actividadLocal: { ...this.actividad },
      enEdicion: false,
      minimizado: false,
      eventos: [],
    };
  },
  methods: {
    toggleEdicion() {
      if (this.enEdicion) {
        this.$emit('guardar', this.actividadLocal);
      }
      this.enEdicion = !this.enEdicion;
    },
    toggleMinimizado() {
      this.minimizado = !this.minimizado;
    },
    async cargarEventos() {
      try {
        const response = await axios.get('/api/eventos');
        this.eventos = response.data;
      } catch (error) {
        console.error('Error al cargar eventos:', error);
      }
    },
  },
  created() {
    this.cargarEventos();
  },
};
</script>

<style scoped>
.tarjeta {
  position: relative; /* necesario para que el badge se posicione bien */
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease-in-out;
}


.tarjeta:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}

.tarjeta-header h6 {
  font-size: 1rem;
  font-weight: 600;
  color: #343a40;
}

.btn-toggle {
  border: none;
  background-color: transparent;
  color: #6c757d;
}
.btn-toggle:hover {
  color: #000;
}

.form-label {
  font-weight: 500;
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}

.info-compacta p {
  font-size: 0.875rem;
  margin: 0;
  color: #495057;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.orden-badge {
  position: absolute;
  top: -10px;
  left: -10px;
  background-color: var(--bs-primary);
  color: white;
  font-weight: bold;
  font-size: 0.85rem;
  padding: 0.35rem 0.7rem;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.4);
  z-index: 1;
}


</style>
